﻿export const jp = {
  apply: "適用",
  cart_is_empty: "カートが空です。商品を追加してください。",
  browse_products: "商品を閲覧する",
  invalid_coupon: "無効な割引コードを入力しました。コードを確認してもう一度お試しください。",
  duplicate_coupon: "割引コード{{couponInputValue}}はすでに適用されています",
  products: "商品",
  product: "商品",
  qty: "数量",
  price: "価格",
  remove: "削除",
  add_to_cart: "カートに追加する",
  show_more: "もっと表示する",
  show_less: "表示を減らす",
  order_summary: "注文のサマリー",
  your_cart: "カート",
  item: "商品",
  items: "商品",
  enter_discount_code: "割引コードを入力",
  continue_shopping: "ショッピングを続ける",
  i_agree: "続行することで、私は次のことに同意したことになります。",
  privacy_policy: "個人情報保護方針",
  refund_policy: "返金ポリシー",
  terms_of_use: "利用規約",
  and: "および",
  total: "合計",
  exclude: "除く",
  include: "含む",
  tax: "消費税",
  subtotal: "小計",
  discount: "割引",
  coupon_discount: "割引クーポン",
  checkout: "お支払いへ",
}